export default __webpack_public_path__ + "static/media/toptech.71555700.png";